/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { District } from './district';
import { Province } from './province';
import { SubDistrict } from './subDistrict';

export interface MemberRequestDto {
  id: string;
  entityType: MemberRequestDto.EntityTypeEnum;
  name: string;
  firstname: string;
  lastname: string;
  cid: string;
  address: string;
  province: Province;
  district: District;
  subDistrict: SubDistrict;
  zipCode: string;
  email: string;
  imageUrl: string;
  documentImageUrl: string;
  signatureImageUrl: string;
  memberTierId: string;
  phone: string;
  isActive: boolean;
  branchId: string;
}
// tslint:disable-next-line:no-namespace
export namespace MemberRequestDto {
  export type EntityTypeEnum = 'individual' | 'corporate';
  export const EntityTypeEnum = {
      Individual: 'individual' as EntityTypeEnum,
      Corporate: 'corporate' as EntityTypeEnum,
  };
}
